<template>
<md-layout md-flex="100" md-gutter="16">
    <md-layout md-flex="25" class="project-box-container" v-for="project in uniqueProjects" :key="project.id">
        <dashboard-project-box
            :project="project"
            @projectAccepted="handleProjectAccepted"
            @projectDeleted="handleProjectDeleted"
        />
    </md-layout>
</md-layout>
</template>

<script>
/**
 * Grid of project tiles. Receives an already-filtered and already-sorted
 * `projects` array from the parent section; renders one tile per project.
 */
import DashboardProjectBox from '@/components/dashboard/project-box';

const ProjectGrid = {
    name: 'ProjectGrid',
    props: ['projects'],
    computed: {
        uniqueProjects() {
            const uniqueMap = new Map();
            for (const project of this.projects || []) {
                if (project && project.id) {
                    uniqueMap.set(project.id, project);
                }
            }
            return Array.from(uniqueMap.values());
        }
    },
    methods: {
        handleProjectAccepted(id) {
            this.$emit('projectAccepted', id);
        },
        handleProjectDeleted(id) {
            this.$emit('projectDeleted', id);
        }
    },
    components: {
        'dashboard-project-box': DashboardProjectBox
    }
};
export default ProjectGrid;
</script>

<style lang="scss">
.project-box-container {
    margin-top: 8px;
    min-width: 0; /* keep the 25% cell from growing to fit a long, un-truncated title */
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// project-grid.vue?36ac6bbe